const ADMIN_LOGGED_IN_KEY = "adminLoggedIn";
const ADMIN_USER_KEY = "adminUser";
const ADMIN_AUTH_CHANGE_EVENT = "admin-auth-change";
const ADMIN_LOGIN_REQUEST_EVENT = "admin-login-request";

const parseAdminUser = (value) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

export const getAdminSession = () => {
  const isLoggedIn = localStorage.getItem(ADMIN_LOGGED_IN_KEY) === "true";
  const admin = parseAdminUser(localStorage.getItem(ADMIN_USER_KEY));

  return {
    isLoggedIn,
    admin,
  };
};

export const isAdminLoggedIn = () => getAdminSession().isLoggedIn;

export const persistAdminSession = (admin) => {
  localStorage.setItem(ADMIN_LOGGED_IN_KEY, "true");
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(admin ?? null));
  window.dispatchEvent(new Event(ADMIN_AUTH_CHANGE_EVENT));
  window.dispatchEvent(new Event("authchange"));
};

export const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_LOGGED_IN_KEY);
  localStorage.removeItem(ADMIN_USER_KEY);
  window.dispatchEvent(new Event(ADMIN_AUTH_CHANGE_EVENT));
  window.dispatchEvent(new Event("authchange"));
};

export const subscribeToAdminAuth = (callback) => {
  const handleChange = () => {
    callback(getAdminSession());
  };

  const handleStorage = (event) => {
    if (event.key && ![ADMIN_LOGGED_IN_KEY, ADMIN_USER_KEY].includes(event.key)) {
      return;
    }

    callback(getAdminSession());
  };

  window.addEventListener(ADMIN_AUTH_CHANGE_EVENT, handleChange);
  window.addEventListener("authchange", handleChange);
  window.addEventListener("storage", handleStorage);

  return () => {
    window.removeEventListener(ADMIN_AUTH_CHANGE_EVENT, handleChange);
    window.removeEventListener("authchange", handleChange);
    window.removeEventListener("storage", handleStorage);
  };
};

export const requestAdminLogin = () => {
  window.dispatchEvent(new Event(ADMIN_LOGIN_REQUEST_EVENT));
};

export const subscribeToAdminLoginRequest = (callback) => {
  window.addEventListener(ADMIN_LOGIN_REQUEST_EVENT, callback);

  return () => {
    window.removeEventListener(ADMIN_LOGIN_REQUEST_EVENT, callback);
  };
};
